// extracted by mini-css-extract-plugin
var _1 = "i338k";
var _2 = "TjV0R";
var _3 = "ZQo3x";
var _4 = "cb6SN";
var _5 = "hduR2";
var _6 = "gEyiF";
var _7 = "CxLxR";
var _8 = "XUbYR";
var _9 = "uwQAj";
var _a = "L9Jfr";
export { _1 as "icon", _2 as "project-details", _3 as "project-details-body", _4 as "project-details-header", _5 as "project-details-label", _6 as "project-details-label-value", _7 as "project-details-label-value--bold", _8 as "project-details-label-value-title", _9 as "project-details-value", _a as "project-details-wrapper" }
